export const PRACTICES = "practices";
export const PROVIDERS = "providers";
export const PROVIDER_LICENSES = "licenses";
export const STATUSES = "statuses";
export const PAYMENT_METHODS = "paymentMethods";
export const ACCEPT_NEW_PATIENTS_STATUS = "acceptingNewPatientsStatus";
export const KNOWN_FILTERS = [PRACTICES, PROVIDERS, PROVIDER_LICENSES, STATUSES, PAYMENT_METHODS, ACCEPT_NEW_PATIENTS_STATUS];
